import { Component } from '@angular/core';
import { SharingDataService } from 'src/sharing-data.service';
import { Router } from '@angular/router';
import { ViewCartService } from '../view-cart/view-cart.service';
import { Cart } from '../view-products/cart.model'
import { AuthService } from 'src/AuthService';
import { Order } from './order.model';

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.css']
})
export class OrderComponent {

   ngAfterViewInit() {
    // This executes right after the HTML hits the screen
    setTimeout(() => {
      // Fake a window resize event to force the browser to snap the header and banner together
      window.dispatchEvent(new Event('resize'));
    }, 50); // A 50ms delay is invisible to the user but enough for the browser
  }

  constructor(private sharingData: SharingDataService,private router: Router , private viewCartService:ViewCartService,private authService : AuthService) {}

  ngOnInit(){
    this.totAmt=0;
    this.sharingData.loggedInCustomerIdVal.subscribe(val => {
    console.log('Received in Order Component:', val);
    this.customerId=val
    
    this.ViewOrdersByCustomerId()
  });

  }
  totAmt=0;
  myOrdersByCustomerId:any;
  customerId:any;
  cartId:number=0;
  cartList:[]=[];
  customerOrdersInCart:any
  myOrders:any;
  order:Order={
  orderDate:new Date(),
  productPrice:'',
  status:'',
  totalAmount:'',
  paymentStatus : '',
  cartId : 0,
  CustomerId:0

};
carIdInOrder:any
orderList:any;
  ViewOrdersByCustomerId(){
     let token=this.authService.getToken();
      console.log("Token is ",token);
      if(token != null || token != undefined){
       this.customerId= localStorage.getItem('customerId');
            this.sharingData.getOrderbyCustomerId(this.customerId).subscribe({
      next:(response) => {
      
        this.myOrdersByCustomerId=response;
        for(let i=0;i<this.myOrdersByCustomerId.length;i++){
          console.log('order cartId',this.myOrdersByCustomerId[i].cart.cartId)
          this.cartId=this.myOrdersByCustomerId[i].cart.cartId;
          this.viewOrderInCartByCartId();
        }
        console.log('View Cart by CustomerId :', this.myOrdersByCustomerId);
      },
      error: (err) => {
        console.error('Error:', err);
      }
    });
      } 
      else {
        alert('Please login to view your orders ');
      }
   
  }

  cartOrder:Cart[]=[]
  viewOrderInCartByCartId(){
    this.viewCartService.viewCartByCartId(this.cartId).subscribe({
       next:(response) => {
        this.customerOrdersInCart=response;
        console.log('View Cart', response);
        this.cartOrder.push(this.customerOrdersInCart);
       
       
      },
    })
  }
customerCart:any;
  viewCartByCustomerId(){
      this.customerId=localStorage.getItem('customerId');
      this.viewCartService.viewCartByCustomerId(this.customerId).subscribe({
       next:(response) => {
        this.customerCart=response;
        console.log('View Cart', response);
       
          this.customerCart = this.customerCart.filter((cart:any) => !this.carIdInOrder.includes(cart.cartId));
      console.log('View Cart after order', response);
      },
    })
  }

   updateOrder(){
     this.viewCartByCustomerId();
    
     for(let i=0;i<this.customerCart.length;i++){
         
             this.order.CustomerId=this.customerId;
             this.order.cartId=this.customerCart[i].cartId;
             this.order.orderDate=new Date();
             this.order.paymentStatus='Pending';
             this.order.totalAmount=this.customerCart[i].cart.productPrice;
             
             this.orderList.push(this.order);
             this.carIdInOrder.push(this.customerCart[i].cartId);
          
        }

     console.log('Order list',this.orderList)
     this.sharingData.updateOrderFn(this.orderList).subscribe({
        next:(response) => {
         this.myOrders=response;
         console.log('update Cart', response);
          this.viewCartByCustomerId()
       },
     })
   }


}
